'use strict';
(()=>{
  const colorMap={'Earl Grey':'#87837b','Vanilla':'#ece7d9','Sesame':'#b0a38d','Cream':'#e3dbc4','Latte':'#b5a28e','Truffle':'#72695c','Charcoal Grey':'#4f514f','Jade White':'#ebece3','Chrome Grey':'#a1a29e','Camel Brown':'#ac8b68','Navy Blue':'#303e50','Metal Grey':'#747570','Moon Pearl':'#cec7b2','Mossy Stone':'#9d9b82','Volcanic Ash':'#6c6c64','Desert Camel':'#bfa786','Sage':'#a4aa8b','Kale':'#68715c','Celtic Salt':'#dad5c7','Black Sesame':'#535149','Oat Milk':'#bcb5a6','Blueberry':'#8c9aa6','Mint':'#a0b9a7','Cloud White':'#eeeae1','Rust':'#a16448','Cobalt':'#667683','Caviar':'#4d4c46','Oat':'#c6bfae','Ivory Beige':'#d0c3a9','Cypress Green':'#52695f','Steel Blue':'#7c929c'};

  function applySwatches(root=document){
    root.querySelectorAll('[data-color]').forEach(swatch=>{
      if(!swatch.style.getPropertyValue('--swatch')){
        const name=swatch.dataset.color.toLowerCase();
        const fallback=name.includes('white')||name.includes('pearl')?'#ebe7dd':name.includes('grey')||name.includes('gray')?'#969991':name.includes('blue')?'#738b9b':name.includes('green')?'#74806a':name.includes('pink')?'#bb9392':name.includes('brown')||name.includes('espresso')?'#78614d':'#bdb09a';
        swatch.style.setProperty('--swatch',colorMap[swatch.dataset.color]||fallback);
      }
      swatch.addEventListener('mouseenter',()=>{
        const card=swatch.closest('.product-card');
        const image=card?.querySelector('.card-image img');
        if(swatch.dataset.swatchImage&&image){
          image.src=swatch.dataset.swatchImage;
          image.removeAttribute('srcset');
          const secondary=card.querySelector('.secondary');
          if(secondary)secondary.hidden=true;
        }
      });
    });
  }

  function initCatalog(){
    const catalog=document.querySelector('[data-catalog]');
    if(!catalog||catalog.dataset.ready)return;
    catalog.dataset.ready='true';
    const grid=catalog.querySelector('.product-grid');
    const cards=[...grid.querySelectorAll('.product-card')];
    const search=catalog.querySelector('#catalog-search');
    const sort=catalog.querySelector('#catalog-sort');
    const load=catalog.querySelector('#load-more');
    const count=catalog.querySelector('#result-count');
    const title=catalog.querySelector('#collection-title');
    const defaultTitle=title.textContent;
    const pageSize=Number(catalog.dataset.pageSize)||12;
    const pieceLabel=catalog.dataset.pieceLabel||'piece';
    const piecesLabel=catalog.dataset.piecesLabel||'pieces';
    const shownConnector=catalog.dataset.shownConnector||'of';
    const names={};
    document.querySelectorAll('[data-filter-category]').forEach(link=>{
      const label=link.querySelector('span')?.textContent.trim()||link.textContent.trim();
      if(link.dataset.filterCategory&&label)names[link.dataset.filterCategory]=label;
    });
    let category=new URLSearchParams(location.search).get('category')||'all';
    let limit=pageSize;
    if(category!=='all'&&!names[category])category='all';

    function render(){
      const term=search?.value.toLowerCase().trim()||'';
      const order=sort?.value||'featured';
      let filtered=cards.filter(card=>(category==='all'||card.dataset.categoryKey===category)&&card.dataset.title.includes(term));
      if(order==='price-low')filtered.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
      if(order==='price-high')filtered.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
      if(order==='name')filtered.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));
      cards.forEach(card=>card.hidden=true);
      filtered.forEach((card,index)=>{grid.append(card);card.hidden=index>=limit;});
      const countLabel=filtered.length===1?pieceLabel:piecesLabel;
      count.textContent=`${filtered.length} ${countLabel}`;
      title.textContent=names[category]||defaultTitle;
      load.hidden=limit>=filtered.length;
      catalog.querySelector('#no-results').hidden=Boolean(filtered.length);
      catalog.querySelector('#shown-count').textContent=filtered.length?`${Math.min(limit,filtered.length)} ${shownConnector} ${filtered.length} ${countLabel}`:'';
      const active=catalog.querySelector('#active-filter');
      active.hidden=category==='all';
      active.querySelector('span').textContent=names[category]||'';
      document.querySelectorAll('[data-filter-category]').forEach(link=>{
        if(link.classList.contains('category-tile'))link.setAttribute('aria-current',link.dataset.filterCategory===category?'true':'false');
      });
    }

    function renderWithTransition(){
      if(document.startViewTransition)document.startViewTransition(render);
      else render();
    }

    search?.addEventListener('input',()=>{limit=pageSize;renderWithTransition();});
    sort?.addEventListener('change',renderWithTransition);
    load.addEventListener('click',()=>{limit+=pageSize;renderWithTransition();});
    catalog.querySelector('#clear-filter').addEventListener('click',()=>{
      category='all';
      limit=pageSize;
      renderWithTransition();
      const url=new URL(location);
      url.searchParams.delete('category');
      history.replaceState({},'',url);
    });
    document.querySelectorAll('[data-filter-category]').forEach(link=>link.addEventListener('click',event=>{
      if(!names[link.dataset.filterCategory])return;
      event.preventDefault();
      category=link.dataset.filterCategory;
      limit=pageSize;
      renderWithTransition();
      const url=new URL(location);
      url.searchParams.set('category',category);
      history.replaceState({},'',url);
      catalog.scrollIntoView({behavior:'smooth'});
    }));
    render();
  }

  function initProduct(){
    const container=document.querySelector('[data-product-page]');
    if(!container||container.dataset.ready)return;
    container.dataset.ready='true';
    const data=document.getElementById('product-variants');
    if(!data)return;
    let variants;
    try{variants=JSON.parse(data.textContent);}catch{return;}
    const select=container.querySelector('#variant-id');
    const selectors=[...container.querySelectorAll('[data-option]')];
    const optionGroups=[...container.querySelectorAll('[data-option-group]')];
    const button=container.querySelector('#add-bag');
    const price=container.querySelector('#detail-price');
    const image=container.querySelector('#selected-image');
    const primaryThumb=container.querySelector('[data-primary-thumbnail]');
    container.querySelector('#variant-fallback').hidden=true;
    container.querySelector('.js-options').hidden=false;

    const updateChoices=()=>{
      optionGroups.forEach(group=>{
        const optionIndex=Number(group.dataset.optionGroup);
        const selector=selectors.find(item=>Number(item.dataset.option)===optionIndex);
        group.querySelectorAll('[data-option-value]').forEach(choice=>{
          const testOptions=selectors.map(item=>item.value);
          testOptions[optionIndex]=choice.dataset.optionValue;
          const possible=variants.some(item=>item.available&&item.options.every((value,index)=>value===testOptions[index]));
          choice.setAttribute('aria-pressed',String(selector?.value===choice.dataset.optionValue));
          choice.disabled=!possible;
        });
      });
    };

    const update=()=>{
      const options=selectors.map(selector=>selector.value);
      const variant=variants.find(item=>item.options.every((option,index)=>option===options[index]));
      updateChoices();
      button.disabled=!variant?.available;
      button.textContent=!variant?container.dataset.unavailableLabel:variant.available?container.dataset.addLabel:container.dataset.soldOutLabel;
      select.disabled=!variant;
      if(!variant){price.textContent=container.dataset.chooseLabel;return;}
      select.value=String(variant.id);
      price.textContent=variant.price;
      if(variant.compare){
        const compare=document.createElement('span');
        compare.className='compare';
        compare.textContent=variant.compare;
        price.append(' ',compare);
      }
      if(image&&variant.image){
        image.src=variant.image;
        image.removeAttribute('srcset');
        if(primaryThumb){
          primaryThumb.dataset.image=variant.image;
          const thumbImage=primaryThumb.querySelector('img');
          if(thumbImage){thumbImage.src=variant.image.replace('width=1600','width=180');thumbImage.removeAttribute('srcset');}
          container.querySelectorAll('[data-image]').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===primaryThumb)));
        }
      }
      const url=new URL(location);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    };
    optionGroups.forEach(group=>group.querySelectorAll('[data-option-value]').forEach(choice=>choice.addEventListener('click',()=>{
      const selector=selectors.find(item=>Number(item.dataset.option)===Number(group.dataset.optionGroup));
      if(!selector||choice.disabled)return;
      selector.value=choice.dataset.optionValue;
      update();
    })));
    selectors.forEach(selector=>selector.addEventListener('change',update));
    container.querySelectorAll('[data-image]').forEach(thumb=>thumb.addEventListener('click',()=>{
      if(!image)return;
      image.src=thumb.dataset.image;
      image.removeAttribute('srcset');
      container.querySelectorAll('[data-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===thumb)));
    }));
    update();
  }

  function cleanDescriptions(){
    document.querySelectorAll('.product-description .rte').forEach(root=>{
      root.querySelectorAll('meta').forEach(node=>node.remove());
      root.querySelectorAll('a').forEach(link=>{if(link.href.includes('admin.shopify.com')||link.className.includes('Polaris-'))link.remove();});
    });
  }

  function initSlideshows(root=document){
    root.querySelectorAll('[data-slideshow]').forEach(slideshow=>{
      if(slideshow.dataset.ready)return;
      slideshow.dataset.ready='true';
      const slides=[...slideshow.querySelectorAll('[data-slide]')];
      const dots=[...slideshow.querySelectorAll('[data-slideshow-dot]')];
      if(!slides.length)return;
      let current=0;
      let timer;
      const show=index=>{
        current=(index+slides.length)%slides.length;
        slides.forEach((slide,slideIndex)=>{
          slide.hidden=slideIndex!==current;
          slide.setAttribute('aria-hidden',String(slideIndex!==current));
        });
        dots.forEach((dot,dotIndex)=>dot.setAttribute('aria-pressed',String(dotIndex===current)));
      };
      const stop=()=>{if(timer){clearInterval(timer);timer=undefined;}};
      const start=()=>{
        stop();
        if(slideshow.dataset.autoplay==='true'&&slides.length>1&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
          timer=setInterval(()=>show(current+1),(Number(slideshow.dataset.interval)||5)*1000);
        }
      };
      slideshow.querySelector('[data-slideshow-previous]')?.addEventListener('click',()=>{show(current-1);start();});
      slideshow.querySelector('[data-slideshow-next]')?.addEventListener('click',()=>{show(current+1);start();});
      dots.forEach(dot=>dot.addEventListener('click',()=>{show(Number(dot.dataset.slideshowDot));start();}));
      slideshow.addEventListener('mouseenter',stop);
      slideshow.addEventListener('mouseleave',start);
      slideshow.addEventListener('focusin',stop);
      slideshow.addEventListener('focusout',start);
      slideshow.showSlide=show;
      show(0);
      start();
    });
  }

  function initRecommendationSlider(section){
    if(!section||section.dataset.sliderReady)return;
    const viewport=section.querySelector('[data-recommendations-viewport]');
    const previous=section.querySelector('[data-recommendations-previous]');
    const next=section.querySelector('[data-recommendations-next]');
    if(!viewport||!previous||!next)return;
    section.dataset.sliderReady='true';
    const update=()=>{
      const max=Math.max(0,viewport.scrollWidth-viewport.clientWidth);
      previous.disabled=viewport.scrollLeft<=2;
      next.disabled=viewport.scrollLeft>=max-2;
    };
    const move=direction=>{
      const item=viewport.querySelector('.recommendations-item');
      const gap=parseFloat(getComputedStyle(viewport.querySelector('.recommendations-track')).gap)||0;
      const distance=item?item.getBoundingClientRect().width+gap:viewport.clientWidth*.8;
      viewport.scrollBy({left:direction*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    };
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    viewport.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  }

  function initBestSellerSliders(root=document){
    root.querySelectorAll('[data-best-sellers]').forEach(section=>{
      if(section.dataset.sliderReady)return;
      const viewport=section.querySelector('[data-best-sellers-viewport]');
      const previous=section.querySelector('[data-best-sellers-previous]');
      const next=section.querySelector('[data-best-sellers-next]');
      if(!viewport||!previous||!next)return;
      section.dataset.sliderReady='true';
      const update=()=>{
        const max=Math.max(0,viewport.scrollWidth-viewport.clientWidth);
        previous.disabled=viewport.scrollLeft<=2;
        next.disabled=max<=2||viewport.scrollLeft>=max-2;
      };
      const move=direction=>{
        const item=viewport.querySelector('.best-sellers__item');
        const gap=parseFloat(getComputedStyle(viewport.querySelector('.best-sellers__grid')).gap)||0;
        const distance=item?item.getBoundingClientRect().width+gap:viewport.clientWidth*.8;
        viewport.scrollBy({left:direction*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      previous.addEventListener('click',()=>move(-1));
      next.addEventListener('click',()=>move(1));
      viewport.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update,{passive:true});
      update();
    });
  }

  function initProductRecommendations(root=document){
    root.querySelectorAll('[data-product-recommendations]').forEach(section=>{
      if(section.dataset.loaded==='true'){
        initRecommendationSlider(section);
        return;
      }
      if(section.dataset.loading)return;
      section.dataset.loading='true';
      const load=()=>fetch(section.dataset.url)
        .then(response=>response.ok?response.text():Promise.reject(new Error('Recommendations unavailable')))
        .then(text=>{
          const page=document.createElement('div');
          page.innerHTML=text;
          const incoming=page.querySelector('[data-product-recommendations]');
          if(!incoming?.querySelector('.recommendations-item')){
            section.remove();
            return;
          }
          section.replaceWith(incoming);
          applySwatches(incoming);
          initRecommendationSlider(incoming);
        })
        .catch(()=>section.remove());
      if('IntersectionObserver' in window){
        const observer=new IntersectionObserver(entries=>{
          if(!entries[0].isIntersecting)return;
          observer.disconnect();
          load();
        },{rootMargin:'0px 0px 300px 0px'});
        observer.observe(section);
      }else load();
    });
  }

  function boot(root=document){applySwatches(root);initCatalog();initProduct();initSlideshows(root);initBestSellerSliders(root);initProductRecommendations(root);cleanDescriptions();}
  boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('shopify:block:select',event=>{
    const slide=event.target.closest?.('[data-slide]');
    const slideshow=slide?.closest('[data-slideshow]');
    if(slide&&slideshow?.showSlide)slideshow.showSlide(Number(slide.dataset.index));
  });
})();
